// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__cEPBS","heading":"faq_heading__0XJt_","column":"faq_column__pwfQA","columns":"faq_columns__EqzEo","list":"faq_list__2cl1d"};